import { BaseModel } from '@fry/lib/store';
import { MFAMethod, MFAMethodsEnum, orderedMFAMethods } from "@fry/lib/auth/account/mfa/mfa";
import { CredentialTypes } from "@fry/lib/auth/account/credential/credential";

export enum Apps {
  RISR_APPLY_LEGACY = 'eas',
  RISR_ADVANCE_LEGACY = 'kaizen',
  RISR_APPLY = 'risr-apply',
  RISR_ADVANCE = 'risr-advance',
}


export class Organisation extends BaseModel {
  allowedAccountTypes: CredentialTypes[];
  enabledMFAs: MFAMethod[];

  constructor(doc) {
    super(doc);
    this.allowedAccountTypes = this.convertAllowedAccountTypes(doc.allowedAccountTypes || []);
    this.enabledMFAs = this.convertMFAIdToMFAMethod(doc.enabledMFAs || []);
  }

  private convertAllowedAccountTypes(allowedAccountTypes: string[]): CredentialTypes[] {
    if (allowedAccountTypes.includes('__all__')) {
      return [CredentialTypes.LOCAL, CredentialTypes.PROXY];
    }

    return allowedAccountTypes as CredentialTypes[];
  }

  private convertMFAIdToMFAMethod(enabledMFAs: MFAMethodsEnum[]): MFAMethod[] {
    return orderedMFAMethods.filter(method => enabledMFAs.includes(method.id));
  }
}
